import React, { useState, useEffect } from 'react';
import { isOnline, onStatusChange, getPendingCount, flushQueue, clearQueue } from '../lib/offline.js';

export default function OfflineBanner() {
  const [online, setOnline] = useState(isOnline());
  const [pending, setPending] = useState(getPendingCount());
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    const unsub = onStatusChange((status) => {
      setOnline(navigator.onLine);
      setPending(getPendingCount());
    });
    const interval = setInterval(() => setPending(getPendingCount()), 2000);
    return () => { unsub(); clearInterval(interval); };
  }, []);

  async function handleSync() {
    setSyncing(true);
    await flushQueue();
    setPending(getPendingCount());
    setSyncing(false);
  }

  function handleClear() {
    if (!confirm('Supprimer les actions en attente ? Elles ne seront pas envoyées.')) return;
    clearQueue();
    setPending(0);
  }

  // Tout va bien
  if (online && pending === 0) return null;

  // En ligne mais actions en attente
  if (online && pending > 0) {
    return (
      <div style={{
        padding: '8px 14px', background: '#FEF3CD', borderBottom: '1px solid #F0C41966',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        fontSize: 12, fontWeight: 600, color: '#7D5A0A',
      }}>
        <span>⏳ {pending} action{pending > 1 ? 's' : ''} en attente</span>
        <div style={{ display: 'flex', gap: 4 }}>
          <button onClick={handleClear} style={{
            padding: '4px 10px', borderRadius: 6, border: '1px solid #C0392B',
            background: 'white', color: '#C0392B', fontSize: 11, fontWeight: 600,
            cursor: 'pointer', fontFamily: 'inherit',
          }}>✕ Supprimer</button>
          <button onClick={handleSync} disabled={syncing} style={{
            padding: '4px 12px', borderRadius: 6, border: 'none',
            background: '#7D5A0A', color: 'white', fontSize: 11, fontWeight: 700,
            cursor: syncing ? 'wait' : 'pointer', fontFamily: 'inherit',
          }}>{syncing ? '⏳…' : '🔄 Sync'}</button>
        </div>
      </div>
    );
  }

  // Hors ligne
  return (
    <div style={{
      padding: '8px 14px', background: '#FDECEA', borderBottom: '1px solid #F5AFA7',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
      fontSize: 12, fontWeight: 700, color: '#C0392B',
    }}>
      <span style={{ fontSize: 16 }}>📡</span>
      Hors ligne — les actions sont sauvegardées localement
      {pending > 0 && <span style={{
        padding: '2px 8px', borderRadius: 10, background: '#C0392B', color: 'white', fontSize: 10,
      }}>{pending}</span>}
    </div>
  );
}
